module.exports = __webpack_public_path__ + "img/tweet.9cfdf008.svg";